import { Link } from "react-router-dom";

export default function SideBar() {
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            ICOM Dashboard
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav" dir="rtl">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to="/" className="nav-link active" aria-current="page">
                  المقالات
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/newartical" className="nav-link">
                  اضافة مقالة
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
